export default "__VITE_ASSET__71f47ec7__"